var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Plus-Circle")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6.0-Vouchers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "my-vouchers",
    transform: "translate(-272.000000, -233.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(16.000000, 231.000000)",
    fill: "#212529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(256.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Plus_circle",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 8.000000) rotate(-360.000000) translate(-8.000000, -8.000000) translate(0.666667, 0.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333333,0 C3.28324517,0 0,3.28324517 0,7.33333333 C0,11.3834215 3.28324517,14.6666667 7.33333333,14.6666667 C11.3834215,14.6666667 14.6666667,11.3834215 14.6666667,7.33333333 C14.6666667,3.28324517 11.3834215,0 7.33333333,0 Z M7.33333333,0.666666667 C11.0152317,0.666666667 14,3.651435 14,7.33333333 C14,11.0152317 11.0152317,14 7.33333333,14 C3.651435,14 0.666666667,11.0152317 0.666666667,7.33333333 C0.666666667,3.651435 3.651435,0.666666667 7.33333333,0.666666667 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66666667,6.66666667 L10,6.66666667 C10.3681898,6.66666667 10.6666667,6.9651435 10.6666667,7.33333333 C10.6666667,7.70152317 10.3681898,8 10,8 L4.66666667,8 C4.29847683,8 4,7.70152317 4,7.33333333 C4,6.9651435 4.29847683,6.66666667 4.66666667,6.66666667 Z",
    id: "Rectangle-185-Copy",
    transform: "translate(7.333333, 7.333333) rotate(-270.000000) translate(-7.333333, -7.333333) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-185",
    x: 4,
    y: 6.66666667,
    width: 6.66666667,
    height: 1.33333333,
    rx: 0.666666667
  })))))))));
};
export default SvgPlusCircle;